import TrendsMobile from "../../../../components/AssetManagement/Overview/Trends/TrendsMobile/TrendsMobileComponents/TrendsMobile";

const TrendsMobileScreen = () => {
  return (
    <>
      <TrendsMobile />
    </>
  );
};

export default TrendsMobileScreen;
